export default __webpack_public_path__ + "static/media/nqt2022-homepage.2c9012eb.png";